import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import axiosInstance from '../../../api/axiosInstance';
// Initial state for the customer data
const initialState = {
  customer: null,
  loading: false,
  error: null,
};

// Create async thunk for the API call
export const getCustomerById = createAsyncThunk(
  'customerData/getCustomerById',
  async ({userId,token}, { rejectWithValue }) => {  
    try {
      const response = await axiosInstance.get(
        `/api/Customer/GetCustomerById?id=${userId}`, 
       {
        headers: {
          Authorization: `Bearer ${token}`,
           'accept': 'text/plain' ,
        },
      }
      );      
      return response.data.message; // assuming data is in message
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

// Slice definition
const customerDataSlice = createSlice({
  name: 'customerData',
  initialState,
  reducers: {
    resetCustomerDataState: (state) => {
      state.loading = false;
      state.error = null;
      state.customer = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCustomerById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCustomerById.fulfilled, (state, action) => {
        state.loading = false;
        state.customer = action.payload;
      })
      .addCase(getCustomerById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetCustomerDataState } = customerDataSlice.actions;
export default customerDataSlice.reducer;
